module.exports = __webpack_public_path__ + "static/media/novo-close.abebf6dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/novo-close.svg
// module id = 160
// module chunks = 0